export default __webpack_public_path__ + "static/media/offer__buy.29ba165b.jpg";